<template>
<div class="pairing px-6">
    <div class="page-title pt-4">
        <v-row>
            <v-col cols="12">
                <h6 class="font-weight-bold text-h5">Asset Command <span class="font-weight-medium"> - Pairing</span></h6>
                <p class="pt-3 mb-0">To track an Asset in Asset Command, the asset must be paired with a Beacon.</p>
            </v-col>
        </v-row>
        <v-row>
      <v-col cols="12" md="4">
          <h4 class="pb-2 font-weight-bold">Beacon ID</h4>
          <v-snackbar
            :timeout="2000"
            :value="paired"
            color="success"
            rounded="pill"
          >
            Beacon got paired with asset successfully
          </v-snackbar>
        <v-autocomplete
          :items="pairingList"
          item-text="beacon_id"
          item-value="beacon_id"
          label="Type here"
          v-model="selectedBeaconID"
          outlined
          dense
          return-object
        ></v-autocomplete>
        <h4 class="pb-2 font-weight-bold">Asset ID</h4>
        <v-text-field
          :items="pairingList"
          label="Type here"
          v-model="selectedAssetID"
          outlined
          dense
          :error-messages="firstCharError"
        ></v-text-field>
        <h4 class="pb-2 font-weight-bold">Asset Owner</h4>
        <v-select
          :items="homeLocations"
          label="Select Asset Owner"
          :value="selectedPairingHomeLocation"
          outlined
          dense
          :disabled="getUserData ? !(getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') : false"
          @change="updateSelectedHomeLocation($event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8">
        <div>
          <p class="orange-clr" v-if="validationMessage != null"> {{ validationMessage }} </p>
            <v-btn
              color="success"
              @click="pairingActionSubmit"
              :disabled="isSubmitDisabled"
              :loading="loadSubmit"
            >
              Submit
            </v-btn>
            <v-btn
              color="error"
              dark
              @click="clearData"
            >
              Cancel
            </v-btn>
          </div>
      </v-col>
    </v-row>
        </div>
</div>
</template>
<script>
/* eslint-disable */
export default ({
    data() {
        return {
            validationMessage: null,
            paired: false,
            loadSubmit: false,
            firstCharError: null,
            formSaved: false
        }
    },
    computed: {
        loading () {
            return this.$store.getters.getLoading
        },
        pairingList () {
            return this.$store.getters.getPairingList
        },
        selectedAssetID: {
            get() {
              return this.$store.getters.getAssetID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_ASSET_ID", value)
            }            
        },
        selectedBeaconID: {
            get() {
              return this.$store.getters.getBeaconID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_Beacon_ID", value)
                if(value != null) {
                    this.$store.commit("SET_SELECTED_ASSET_ID", value.asset_id)
                    if(this.getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                      this.$store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', value.ASSET_OWNER)
                    }
                } else {
                    this.$store.commit("SET_SELECTED_ASSET_ID", null)
                    if(this.getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                      this.$store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', 'ALL')
                    }
                }
                this.firstCharError = ''; 
            }
        },
        getUserData() {
          return this.$store.getters.getUserInfo;
        },
        selectedPairingHomeLocation () {
          return this.$store.getters.getSelectedPairingHomeLocation
        },
        homeLocations () {
          return this.$store.getters.getHomeLocationList.filter(item => item != 'ALL').sort();
        },
        isSubmitDisabled() {
            return !this.isFormValid || this.formSaved;
        },
        isFormValid() {
            return this.validationMessage === null &&
                   this.firstCharError == null &&
                   this.selectedBeaconID &&
                   this.selectedAssetID &&
                   (this.selectedPairingHomeLocation !== 'ALL' && 
                   this.selectedPairingHomeLocation !== null && 
                   this.selectedPairingHomeLocation !== '');
        }
    },
    methods: {
        getPairingList () {
          var loc;
          if (this.getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
            loc = 'ALL';
          } else {
            loc = this.selectedPairingHomeLocation
          }
            this.$store.dispatch('getDeviceData', {"widget": "GET_ASSET_PAIRING_DATA", userOrgHomeLocation: loc});
        },
        pairingActionSubmit () {
          this.paired = false
          this.loadSubmit = true
          var pairingReq = {"widget": "POST_ASSET_PAIRING_DATA", userOrgHomeLocation: this.selectedPairingHomeLocation}
            if (this.selectedBeaconID.asset_id == null) {
               var isPaired = this.pairingList.find((item) => item.asset_id == this.selectedAssetID)
               if (isPaired) {
                 pairingReq.BeconID = this.selectedBeaconID.beacon_id
                 pairingReq.AssetID = this.selectedAssetID
                 pairingReq.action = "update"
                 pairingReq.OldBeaconID = isPaired.beacon_id
               } else {
                 pairingReq.BeconID = this.selectedBeaconID.beacon_id
                 pairingReq.AssetID = this.selectedAssetID
                 pairingReq.action = "create"
                 pairingReq.Location = this.selectedBeaconID.location
               }              
              this.validationMessage = null
            } else {
                pairingReq.BeconID = this.selectedBeaconID.beacon_id
                pairingReq.AssetID = this.selectedAssetID
                pairingReq.action = "update"
                pairingReq.OldAssetID = this.selectedBeaconID.asset_id
                this.validationMessage = null
            }
          if (this.validationMessage == null) {
            this.$store.dispatch('getDeviceData', pairingReq)
            this.selectedBeaconID.asset_id = this.selectedAssetID
            let vm = this
            setTimeout(function(){
              vm.paired = true
              vm.loadSubmit = false
              vm.formSaved = true
            }, 4000)
          }
        },
        clearData() {
          this.validationMessage = null
          this.selectedBeaconID = null
        },
        updateSelectedHomeLocation(val) {
           this.$store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', val)
        },

    validateFirstChar(event) {
      const input = typeof event === 'string' ? event : event.key;
      this.firstCharError = 'First character of Asset must be A, B, or C';
      if ((!['A', 'B', 'C'].includes(input[0].toUpperCase()))) {
        if (typeof event !== 'string')
          event.preventDefault();
      } else {
        this.firstCharError = null;
      }
    }
  },
    beforeMount () {
        this.getPairingList()
        this.selectedBeaconID = null
        this.selectedAssetID = null;
        this.selectedPairingHomeLocation = null;
    },
    mounted() {
      if(this.selectedAssetID != null) {
        var alreadyPaired = this.pairingList.find((item) => item.asset_id == this.selectedAssetID)
        if (alreadyPaired) {
          this.validationMessage =`The Device ${alreadyPaired.beacon_id} you entered is already paired with the Asset ${alreadyPaired.asset_id}. Only proceed with entering a new Asset ID if the Device has been removed from the existing Asset and will be attached to a new Asset`
        } else {
          this.validationMessage = null
        }
      } else {
        this.validationMessage = null
      }
    },
    watch: {
      selectedAssetID (val) {
        if (val != null) {
          var alreadyPaired = this.pairingList.find((item) => item.asset_id == val)
          if (alreadyPaired) {
            if (this.selectedBeaconID.asset_id != null) {
              if (this.selectedBeaconID.beacon_id == alreadyPaired.beacon_id) {
              this.validationMessage =`The Device ${alreadyPaired.beacon_id} you entered is already paired with the Asset ${alreadyPaired.asset_id}. Only proceed with entering a new Asset ID if the Device has been removed from the existing Asset and will be attached to a new Asset.`
              } else {
                this.validationMessage =`The Asset ${alreadyPaired.asset_id} you entered is already paired with the Device ${alreadyPaired.beacon_id}. The device selected ${this.selectedBeaconID.beacon_id} is already paired with ${this.selectedBeaconID.asset_id}.  You can only pair to a new device for an existing asset.`
              }
            }else {
              this.validationMessage =`The Asset ${alreadyPaired.asset_id} you entered is already paired with the Device ${alreadyPaired.beacon_id}. Proceed only if the current Device is being replaced with the new Device ${this.selectedBeaconID.beacon_id} entered`
            }
          } else {
            this.validationMessage = null
          }
          this.validateFirstChar(val); //check for 1st char A, B,C
        } else {
           this.validationMessage = null
        }
        this.formSaved = false
      },
      selectedPairingHomeLocation() { this.formSaved = false }
    }
})
</script>



// WEBPACK FOOTER //
// src/components/pages/pairing.vue